function productionLogger() {
  return {
    info: () => ({}),
    debug: () => ({}),
    warn: () => ({}),
    error: () => ({})
  };
}

function developmentLogger() {
  return {
    info: str => {
      console.info(str);
    },
    debug: str => {
      console.debug(str);
    },
    warn: str => {
      console.warn(str);
    },
    error: str => {
      console.error(str);
    }
  };
}

const getLogger = () =>
  (process.env.NODE_ENV === "production"
    ? productionLogger
    : developmentLogger)();

export const logger = getLogger();

export default {
  install(Vue) {
    Vue.prototype.$logger = logger;
  }
};
